import React from "react";
import { motion } from "motion/react";
import { Camera, ChevronLeft, CheckCircle, ChevronRight } from "lucide-react";
import AvatarUpload from "./AvatarUpload";

export default function StepPhoto({ userId, avatarUrl, onAvatarChange, profileName, onBack, onFinish }) {
  return (
    <motion.div
      id="onboarding-step-photo_root"
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -40 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-600/20 flex items-center justify-center">
          <Camera className="w-8 h-8 text-primary-400" />
        </div>
        <h2 className="text-2xl font-medium text-white mb-2">Фото профиля</h2>
        <p className="text-lg font-extralight text-neutral-400">
          Добавьте фото, чтобы клиенты видели, с кем работают
        </p>
      </div>

      <div className="p-6 rounded-md bg-neutral-900 border border-neutral-800">
        <div className="flex flex-col items-center gap-6">
          <div className="relative">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={profileName}
                className="w-32 h-32 rounded-full object-cover border-2 border-primary-500/30"
              />
            ) : (
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center border-2 border-neutral-700">
                <span className="text-white text-4xl font-medium">
                  {profileName?.[0] || "?"}
                </span>
              </div>
            )}
          </div>

          <AvatarUpload
            userId={userId}
            currentAvatarUrl={avatarUrl}
            onAvatarChange={onAvatarChange}
          />
        </div>
      </div>

      {!avatarUrl && (
        <div className="flex items-center gap-3 p-4 rounded-md bg-amber-500/10 border border-amber-500/20">
          <Camera className="w-5 h-5 text-amber-400 flex-shrink-0" />
          <p className="text-lg font-extralight text-amber-300/80">
            Профили с фото получают в 3 раза больше откликов
          </p>
        </div>
      )}

      {avatarUrl && (
        <div className="flex items-center gap-3 p-4 rounded-md bg-accent-500/10 border border-accent-500/20">
          <CheckCircle className="w-5 h-5 text-accent-400 flex-shrink-0" />
          <p className="text-lg font-extralight text-accent-300/80">
            Отлично! Фото загружено
          </p>
        </div>
      )}

      <div className="flex justify-between gap-3 pt-4">
        <button
          onClick={onBack}
          className="flex items-center gap-2 px-5 py-2.5 rounded-md border border-neutral-700 text-neutral-300 hover:text-white text-lg font-extralight transition-colors"
        >
          <ChevronLeft className="w-4 h-4" /> Назад
        </button>
        <div className="flex items-center gap-3">
          {!avatarUrl && (
            <button
              onClick={onFinish}
              className="flex items-center gap-2 px-5 py-2.5 rounded-md border border-neutral-700 text-neutral-400 hover:text-white text-lg font-extralight transition-colors"
            >
              Пропустить <ChevronRight className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={onFinish}
            className="flex items-center gap-2 px-6 py-3 rounded-md bg-accent-600 hover:bg-accent-500 text-white text-lg font-medium transition-colors"
          >
            <CheckCircle className="w-5 h-5" /> Завершить настройку
          </button>
        </div>
      </div>
    </motion.div>
  );
}
